import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CreateByMassiveExcelRequest {
  orderRequestId: string;
  excelFile: File;
  portfolioId?: string;
  processManagerId?: string;
  forceLaunchToExchange: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MassiveServicesService {
  private readonly API_URL = `${environment.apiUrl}/es/Appraisals/CreateByMassiveExcel`;

  constructor(private http: HttpClient) {}

  createByMassiveExcel(request: CreateByMassiveExcelRequest): Observable<any> {
    const formData = new FormData();
    formData.append('orderRequestId', request.orderRequestId);
    formData.append('excelFile', request.excelFile, request.excelFile.name);
    if (request.portfolioId) {
      formData.append('portfolioId', request.portfolioId);
    }
    if (request.processManagerId) {
      formData.append('processManagerId', request.processManagerId);
    }
    formData.append('forceLaunchToExchange', String(request.forceLaunchToExchange));

    return this.http.post(this.API_URL, formData);
  }
}
